import { BehaviorSubject } from 'rxjs'
import { RxJS } from './RxJS'
import { MainMenuApp } from '../../constants/AppMenuConstants'
import { isVarNotEmpty } from '../../utils/GlobalFunctions'
import { RxJSState, SubMenuItem } from '../Types/Types'

const subMenuItemsSubject: BehaviorSubject<Record<MainMenuApp, SubMenuItem[]>> = new BehaviorSubject<
    Record<MainMenuApp, SubMenuItem[]>
>({
    [MainMenuApp.REPORTING]: [],
    [MainMenuApp.ADMIN]: [],
    [MainMenuApp.FAST_PROVISIONING]: [],
    [MainMenuApp.STATUS]: []
})

RxJS.subMenuItems = RxJS.subMenuItems ?? {
    subject: subMenuItemsSubject,
    observable: subMenuItemsSubject.asObservable(),
    announce: (data: Record<MainMenuApp, SubMenuItem[]>): void => {
        if (isVarNotEmpty(data)) {
            subMenuItemsSubject.next(data)
        }
    }
}

export const subMenuItemsState$: RxJSState<Record<MainMenuApp, SubMenuItem[]>> = RxJS.subMenuItems
